import doLoad from './methodDoLoad'
import { mapActions, mapMutations } from 'vuex'

export default {
  doLoad,
  ...mapActions('app/patient/agendas', [
    'loadAgendas'
  ]),
  ...mapMutations('app/patient/agendas', [
    'setFilters',
    'setLoading',
    'setValuesSearchedBy'
  ]),
  prepareShow (favoriteList) {
    return favoriteList
  },
  doSearchByProfessionalFavorite (favotite) {
    // passando o professional para seleção das agendas nas buscas
    this.doLoad(favotite.professional)
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/favorite-list/resources/methods.js